import React from 'react';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';

export default function Services() {
  return (
    <div className="section">
      <h1 className="fw-bold mb-3">Services</h1>
      <p className="fs-5 mb-2">
        M3 Computing works across three interconnected service areas: cloud consulting, software
        development, and technical education. Most engagements touch more than one.
      </p>
      <p className="fs-5 mb-5">
        Every engagement starts the same way — with a conversation about your mission. If we
        can't get behind what you're building, we won't take the work. That filter keeps us
        focused on clients where we can deliver real value.
      </p>

      <Row className="g-4">
        <Col md={12}>
          <Card className="m3-service-card-lg">
            <Card.Body>
              <Row>
                <Col md={4}>
                  <Card.Title as="h2" className="mb-3">Consulting</Card.Title>
                  <Link to="/consulting" className="m3-card-link">Learn more →</Link>
                </Col>
                <Col md={8}>
                  <p className="mb-2">
                    Cloud strategy and architecture consulting for companies building on or
                    migrating to the cloud. We help you design the right foundations — and avoid
                    the expensive rewrites that happen when those foundations are wrong.
                  </p>
                  <p className="mb-0 text-muted">
                    Cloud architecture &amp; modernization &nbsp;·&nbsp; SaaS strategy &amp;
                    roadmapping &nbsp;·&nbsp; Multi-cloud design &nbsp;·&nbsp; Cloud cost
                    optimization
                  </p>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>

        <Col md={12}>
          <Card className="m3-service-card-lg">
            <Card.Body>
              <Row>
                <Col md={4}>
                  <Card.Title as="h2" className="mb-3">Development</Card.Title>
                  <Link to="/development" className="m3-card-link">Learn more →</Link>
                </Col>
                <Col md={8}>
                  <p className="mb-2">
                    Senior-level engineering across two distinct disciplines: cloud-native
                    platform development and SaaS product development. We design, build, test,
                    document, and hand over code your team can maintain.
                  </p>
                  <p className="mb-0 text-muted">
                    Cloud-native development &nbsp;·&nbsp; Kubernetes &amp; platform engineering
                    &nbsp;·&nbsp; SaaS architecture &nbsp;·&nbsp; API design &nbsp;·&nbsp; Java,
                    Go, Python
                  </p>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>

        <Col md={12}>
          <Card className="m3-service-card-lg">
            <Card.Body>
              <Row>
                <Col md={4}>
                  <Card.Title as="h2" className="mb-3">Education</Card.Title>
                  <Link to="/education" className="m3-card-link">Learn more →</Link>
                </Col>
                <Col md={8}>
                  <p className="mb-2">
                    Technical education delivered in three formats: live custom training
                    workshops, custom-produced video courses, and ongoing technical advisory.
                    Education isn't an add-on — it's the reason clients don't stay dependent
                    on their consultants.
                  </p>
                  <p className="mb-0 text-muted">
                    Live workshops &nbsp;·&nbsp; Custom video course production &nbsp;·&nbsp;
                    Technical mentoring &nbsp;·&nbsp; Architecture advisory
                  </p>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
